import { InjectionToken } from '@angular/core';

import { RelatedProductsRepositoryInterface } from '../../domain/related-products-repository.interface';

export const RELATED_PRODUCTS_REPOSITORY = new InjectionToken<RelatedProductsRepositoryInterface>('RelatedProductsRepositoryInterface');
